import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Ad, cpDcService } from 'src/app/services/cp-dc/cp-dc.service';
import { cpcCpm } from 'src/app/services/cp-dc/cpc-cpm.enum';
import { cpmService } from 'src/app/services/cp-dc/cpm.service';
import { VideoPopupService } from 'src/app/services/cp-dc/video-popup.service';
import { UnlServiceService } from 'src/app/services/unl-service.service';

@Component({
  selector: 'app-cpc-cdc',
  templateUrl: './cpc-cdc.component.html',
  styleUrls: ['./cpc-cdc.component.scss']
})
export class CpcCdcComponent {
  @Input() index: number = 24;
  cpDc: Ad = null;
  @Input() bigAdd = false;
  isModalOpen1 = false;
  @Output() close = new EventEmitter<void>();
  @Output() open = new EventEmitter<Ad>();
  @Input() addType: cpcCpm = cpcCpm.cpc

  ngOnInit() {
    if (this.addType === cpcCpm.cpc) {
      this.getAdByIndex(this.adService);
    } else {
      this.getAdByIndex(this.cpmService);
    }
  }
  
  private getAdByIndex(service: any) {
    service.getAdByIndex(this.index).subscribe(res => {
      this.cpDc = res;
      const vpD = {
        isFromCpc : true,
        asInlineAdd : true,
      }
      this.unlServiceService.getvideodetails(vpD);
    });
  }
  


  //@Input() index: number;
  ad: any; // Replace with your actual ad type
  private intersectionObserver: IntersectionObserver;
  private destroy$ = new Subject<void>();

  constructor(
    private adService: cpDcService,
    private cpmService: cpmService,
    private route:ActivatedRoute,private router:Router,
    private unlServiceService: UnlServiceService,
    private videoPopupService: VideoPopupService,
    private elementRef: ElementRef<HTMLElement>
  ) { }

  ngAfterViewInit() {
    const options = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.5 // 50% of the component visible
    };

    this.intersectionObserver = new IntersectionObserver(
      entries => this.onIntersection(entries),
      options
    );

    this.intersectionObserver.observe(this.elementRef.nativeElement);
  }

  private onIntersection(entries: IntersectionObserverEntry[]) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.callImpressionApi();
      }
    });
  }

  private callImpressionApi() {
    const url = this.cpDc.beacons[0] && this.cpDc.beacons[0].url;
    if (!this.cpDc.beacons[0].url) {
      return;
    }
    if (this.addType === cpcCpm.cpc) {
      this.adService.recordImpression(url).subscribe(
        (data) => {
          if (data) {
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status === 0) {

          } else {
          }
        }
      );
    } else {
      this.cpmService.recordImpression(url).subscribe(
        (data) => {
          if (data) {
          }
        },
        (error: HttpErrorResponse) => {
          console.error('HTTP Error:', error.status);
          if (error.status === 0) {
  
          } else {

          }
        }
      );
    }
  }

  ngOnDestroy() {
    this.intersectionObserver.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }

  openModal12() {
    //this.open.emit(this.cpDc);
  }

  closeModal12() {
    //this.close.emit();
  }

  clickBat() {
    if (!this.cpDc.videos || this.cpDc.videos.length === 0) {
      //window.open(this.cpDc.clickUrl, "_blank");
      const newTab = window.open();
      newTab.location.href = this.cpDc.clickUrl;
      window.focus(); 
    } else {
      this.callImpressionApi();
      this.navigateToVideo();
    }
  }

  navigateToVideo(): void {
    const vpD = {
      title: this.cpDc.customization.Headline,
      crr: this.cpDc.videos[0].url,
      vidCatname: this.cpDc.customization.Teaser,
      vidpath: this.cpDc.clickUrl,
      isFromCpc : true,
      clickUrl: this.cpDc.clickUrl,
    }
    this.videoPopupService.updateVideoSub(this.cpDc);
    const urlText = this.urltext(this.cpDc.customization.Headline);
    this.openPopup();
  }

  urltext(title: string): string {
    return title.replace(/\s+/g, '-').toLowerCase();
  }

  openPopup() {
    this.videoPopupService.updateOpenVideoAddSub(true);
  }
}
